var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatured(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 757.6 883.2",
    style: {
      enableBackground: "new 0 0 757.6 883.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.15;fill:#0066A6;}\r\n\t.st1{fill:#171042;}\r\n\t.st2{fill:#1D2858;}\r\n\t.st3{fill:#F1F1F1;}\r\n\t.st4{fill:#F6B690;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{opacity:0.43;fill:#17898D;}\r\n\t.st7{opacity:0.25;fill:#17898D;}\r\n\t.st8{opacity:0.9;fill:none;stroke:#00205C;stroke-miterlimit:10;}\r\n\t.st9{fill:#F6B690;stroke:#000000;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st10{fill:#17898D;}\r\n\t.st11{fill:#01687F;}\r\n\t.st12{fill:#F18A00;}\r\n\t.st13{fill:#F6B690;stroke:#F6B690;stroke-miterlimit:10;}\r\n\t.st14{fill:#F26522;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000024003904920446508570000003468025852729716865_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M649.9,270c-1.7,4.3-3.9,7.3-4.9,10.9c-0.9,3.5-0.8,22.4-0.3,34.4c7,11.2,10.4,27.4,11.3,45.2 c1.2,24.5,18,54,18,71.1c0,11.1-9.2,29.9-25.6,36.2c5.4,42.1-1.7,91.2-4.2,94.9c3.4,15,11.8,63.6,18.7,102.4 c39.3-46,67.7-98.4,81.6-154.8C763.7,431,754.6,344,720,279.6L649.9,270z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M733.5,819.5c-3.7-5.1-57.7-90.3-61.1-103.3c-3.1-11.9-22.7-128.7-28.2-153.6l0,0c-2.9,0.6-9.5,0.1-17.9-1.2 c-26.5,22.2-20.8,126.6-18.9,131.6c2.3,6,94.7,140,102.6,146.2C717.9,839.3,734.6,826.9,733.5,819.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M640.8,562.9c-18.8,0-85-15.4-94.4-24.7c1,20.1,14.7,134.4,16.5,150.7c1.9,17.5,31.9,158.5,34.5,162 s22.8,2.8,26.3,1s-6.8-147-6.8-157.5C616.9,684.3,641.6,595.5,640.8,562.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M677.1,223.6c-41.1-37.1-98-52.9-162-60.3v77.9l11.6,1.6c2.6-4,5.9-7.1,8-7.1c1.7,1.2,3.7,4.8,5.5,9 l86.6,11.8v-1.1c0-4.5,3.7-8.2,8.2-8.2c0,0,0,0,0,0h1c4.5,0,8.2,3.7,8.2,8.2c0,0,0,0,0,0v3.4l0.8,0.1c0.4-2.8,1-5.9,4.2-5.2 c1,0.2,1.6,3.1,1.9,6l62.4,8.5C703.7,251.8,691.3,236.7,677.1,223.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M547.3,256l-3.2-0.4c0.6,2,1.1,4.1,1.4,6.2C545.8,259.7,546.4,257.8,547.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M627.6,266.9l-70.6-9.7c-0.8,6.5-3.3,12.7-7.2,18c0.3,7.6,10,83.3,11.6,87.7c1.2,3.4,12.1,21.2,17,30.3 c1-0.2,2.1-0.2,3.1,0c2.1,0.3,6.8,7.8,11.1,17.8c2.8-1.9,6-3.3,9.3-4v-25c-12.2-4.6-21.2-19.7-21.2-37.5c0-6.4,1.2-12.7,3.5-18.7 c-0.4-1.9-0.7-3.8-0.7-5.8c0-11.9,12.7-20.1,34.7-20.1c2.3,0,4.6,0.2,6.8,0.7c1.8-10.2,3.6-20.6,4.2-23.3 C630.8,271.2,626.4,267.3,627.6,266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M546.4,538.2c-0.5-0.5-0.9-1-1.1-1.7c-3.4-18.5,5.3-58.3,20-89c-11.2-11-20.5-24.2-20.8-26.6 c-0.2-1.9,1-4.4,3-7.2c-4.9-8.4-13-27.8-14-32.9c-1.1-5.9-4-94.7-4-100s-7-18.5-7-26.4c0-0.6,0-1.3,0.1-1.9l-7.6-1v234.3 c0,12.4-10,22.4-22.4,22.4c0,0,0,0,0,0H157.9c-12.4,0-22.4-10.1-22.4-22.4c0,0,0,0,0,0V179.7c-17.1,7.5-32.2,17.2-44.6,29.6 c-59.1,59.3-58.8,180.9-36.6,305C76.7,638.5,120.9,765,209.7,813s221.8,17.3,326.8-43.9c12.8-7.5,25.2-15.4,37.1-23.8 c-5.5-26.9-10.1-50-10.8-56.5C561.1,672.6,547.4,558.4,546.4,538.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M617.7,709.3c0,0.5,0,0.9,0.1,1.4l0.5-0.5L617.7,709.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M635.1,247.2h1c4.5,0,8.2,3.7,8.2,8.2v4.2c0,4.5-3.7,8.2-8.2,8.2h-1c-4.5,0-8.2-3.7-8.2-8.2v-4.2 C626.9,250.9,630.6,247.2,635.1,247.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 601.9,
    y1: 407,
    x2: 601.9,
    y2: 382
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M157.9,128.7h334.7c12.4,0,22.4,10,22.4,22.4v334.7c0,12.4-10,22.4-22.4,22.4H157.9 c-12.4,0-22.4-10-22.4-22.4V151.1C135.5,138.7,145.6,128.7,157.9,128.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M349,301.6c14.3-13.1,15.2-35.3,2.1-49.6c-13.1-14.3-35.3-15.2-49.6-2.1c-14.3,13.1-15.2,35.3-2.1,49.6 c0.7,0.7,1.4,1.5,2.1,2.1l-27,109.6H376L349,301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203.5,128.7c0.6-67.3,55.7-121.4,123-120.8c66.4,0.6,120.1,54.3,120.8,120.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 609.7,
    cy: 344.5,
    rx: 29,
    ry: 39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M565.3,447.6c-14.7,30.7-23.5,70.5-20,89c1.8,9.6,85.9,28.8,98.8,26.2c4.6-6.2,23.2-156.1-38.3-156.1 c-4.7,0.1-9.3,1.7-13.2,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M600.2,456.6c7.7-17.1-13.4-62.5-18.8-63.3c-10.8-1.8-37.8,19-36.9,27.7c0.3,3.1,16.6,25.4,32,36.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.6,
    y: 77.2,
    transform: "matrix(0.1354 -0.9908 0.9908 0.1354 254.2012 803.8598)",
    className: "st12",
    width: 10.2,
    height: 358.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.6,
    y: 242.3,
    transform: "matrix(0.1354 -0.9908 0.9908 0.1354 110.8419 633.5534)",
    className: "st12",
    width: 29.6,
    height: 21.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.5,
    y: 250.9,
    transform: "matrix(0.1354 -0.9908 0.9908 0.1354 129.7342 662.2921)",
    className: "st12",
    width: 29.6,
    height: 11.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M645.3,324.9c-0.8-4.7-1.6-39.1-0.3-43.9s4.7-8.4,6.3-15.6c0.5-2.5-0.3-11.1-2-11.5c-3.6-0.8-3.8,3.3-4.3,6.3 c-1.9,10.2-5.7,8.4-7.4,8.1s-7.8-1.3-9.7-1.3s3,4,1.5,10.5c-1.2,5.1-6.8,39-8,44.5C625.6,322.1,645.3,324.9,645.3,324.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.4,
    y: 253.6,
    transform: "matrix(0.1354 -0.9908 0.9908 0.1354 144.2598 684.3804)",
    className: "st12",
    width: 29.6,
    height: 11.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.9,
    y: 215,
    transform: "matrix(0.1354 -0.9908 0.9908 0.1354 136.2369 649.2834)",
    className: "st12",
    width: 10.5,
    height: 63.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M775.2,254.9c-14.5-2-27.9,8.2-29.9,22.7s8.2,27.9,22.7,29.9c14.5,2,27.9-8.2,29.9-22.7 C799.9,270.3,789.8,256.9,775.2,254.9C775.3,254.9,775.3,254.9,775.2,254.9z M789.6,283.7c-1.4,9.9-10.5,16.8-20.4,15.5 c-9.9-1.4-16.8-10.5-15.5-20.4c1.4-9.9,10.5-16.8,20.4-15.5c0,0,0,0,0,0C784,264.7,790.9,273.8,789.6,283.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M732,822.1l22.3,28.3l-26.2,37l-24.6,0.2l22.4-29.8l-12.3-20.6L732,822.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "621.4,850.6 622.9,887.6 549.7,887.6 601.6,865.5 602.6,850.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M547.2,414.5c-4.9-8.4-13-27.8-14-32.9c-1.1-5.9-4-94.7-4-100s-7-18.5-7-26.4s8.1-18.7,12.2-18.8 c4.4,3.1,10.5,21.4,10.7,26c1.5-10,8.8-12.3,10.8-12.3s1.7,15.4-6.5,25.8c0.3,7.6,10,83.3,11.6,87.7c1.2,3.4,12.1,21.2,17,30.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M655.9,360.6c-1.6-33-11.9-60.6-37.6-60.6c-22,0-34.7,8.2-34.7,20.1s7.6,20,20,24.8c2.6-3.4,7.5-4,10.9-1.4 c3.4,2.6,4,7.5,1.4,10.9c-1.5,1.9-3.7,3-6.1,3c-0.3,0-0.7,0-1-0.1c0.8,8.6,2.4,11.2,2.4,19.6c0,24.2-4.1,12.1-4.1,53.9 c0,25.2,10.6,38.9,30,38.9c23.5,0,37-24.9,37-38.3C674,414.6,657.1,385.1,655.9,360.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M602.6,346.6c1.7-4,6.2-5.8,10.2-4.2c4,1.7,5.8,6.2,4.2,10.2s-6.2,5.8-10.2,4.2c-0.2-0.1-0.3-0.1-0.5-0.2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatured);
export default __webpack_public_path__ + "static/media/featured.619c27a68fcaf69e7f4fffc039fc6959.svg";
export { ForwardRef as ReactComponent };